<!-- image -->
@if (heroPost) {
    <blog-hero-picture
        class="hero-picture"
        [article]="heroPost"
        [cursorPointer]="true"
        [breakpoint]="breakpoint"
        (tagClicked)="tagClicked($event)"
        (pictureClicked)="postClicked($event)"
    ></blog-hero-picture>
}

<div class="content-wrapper">
    @if (env.preview) {
        <div class="buttons-row-preview">
            <blog-fs-add-page
                [isArticle]="false"
                [label]="(labels | async)?.create_author ?? ''"
            ></blog-fs-add-page>
            <blog-fs-add-page [label]="(labels | async)?.create_article ?? ''"></blog-fs-add-page>
            <blog-fs-blog-layout
                [previewId]="layoutPreviewId"
                [label]="(labels | async)?.blog_layout ?? ''"
            ></blog-fs-blog-layout>
        </div>
    }
</div>

<!-- boosted articles -->
@if (boostedBlogPosts.length) {
    <sew-ws-content-wrapper>
        <h2 class="typo-ws-h2" [innerHTML]="(labels | async)?.boosted_articles"></h2>
        <div class="grid grid--three-columns">
            @for (boostedPost of boostedBlogPosts; track boostedPost) {
                <blog-post
                    (postClicked)="postClicked($event)"
                    (tagClicked)="tagClicked($event)"
                    [post]="boostedPost"
                    [size]="'m'"
                    class="no-padding"
                ></blog-post>
            }
        </div>
    </sew-ws-content-wrapper>
}

@if (!filteredTags.length) {
    <!-- all articles -->
    <sew-ws-content-wrapper>
        <div class="all-articles-search">
            <h2 [innerHTML]="(labels | async)?.all_articles"></h2>
            <!-- search -->
            <blog-search [query]="searchQuery" (closeSearch)="onCloseSearch()"></blog-search>
        </div>
    </sew-ws-content-wrapper>
    @if (!searchQuery) {
        <sew-ws-content-wrapper no-margin>
            <div class="grid grid--three-columns">
                <!-- first article -->
                @if (firstPost) {
                    <blog-post
                        (postClicked)="postClicked($event)"
                        (tagClicked)="tagClicked($event)"
                        [post]="firstPost"
                        [size]="'m'"
                        slot="teaser-item"
                        class="no-padding"
                    ></blog-post>
                }
                <!-- second article -->
                @if (secondPost) {
                    <blog-post
                        (postClicked)="postClicked($event)"
                        (tagClicked)="tagClicked($event)"
                        [post]="secondPost"
                        [size]="'m'"
                        slot="teaser-item"
                        class="no-padding"
                    ></blog-post>
                }
                @if (thirdPost) {
                    <blog-post
                        (postClicked)="postClicked($event)"
                        (tagClicked)="tagClicked($event)"
                        [post]="thirdPost"
                        [size]="'m'"
                        slot="teaser-item"
                        class="no-padding"
                    ></blog-post>
                }
            </div>
        </sew-ws-content-wrapper>
        @if (showForm) {
            <sew-ws-content-wrapper no-margin>
                <div class="subscribe-container" (click)="openSubscribeDialog('subscribe-modal-landing')">
                    {{ (labels | async)?.subscribeHeadline }}
                    <sew-icon class="subscribe-icon" icon="bell"></sew-icon>
                </div>
            </sew-ws-content-wrapper>
            <blog-modal id="subscribe-modal-landing">
                <div class="modal-subscribe-wrapper">
                    <div class="form-wrapper form-width">
                        <blog-form [darkTheme]="true" [labels]="(labels | async) ?? undefined"></blog-form>
                    </div>
                    <div class="close" (click)="closeSubscribeDialog('subscribe-modal-landing')">
                        <img src="assets/images/close_light.svg" />
                    </div>
                </div>
            </blog-modal>
        }
        <sew-ws-content-wrapper no-margin>
            <div class="grid grid--six-columns">
                @for (post of blogPosts; track post; let idx = $index) {
                    <blog-post
                        (postClicked)="postClicked($event)"
                        (tagClicked)="tagClicked($event)"
                        [post]="post"
                        [size]="'m'"
                        [ngClass]="getTeaserClass(idx)"
                    ></blog-post>
                }
            </div>
        </sew-ws-content-wrapper>
    } @else {
        <sew-ws-content-wrapper no-margin>
            <div class="grid grid--six-columns">
                @for (blogPosts of searchResults; track blogPosts; let idx = $index) {
                    <blog-post
                        (postClicked)="postClicked($event)"
                        (tagClicked)="tagClicked($event)"
                        [post]="blogPosts"
                        [size]="'m'"
                        slot="teaser-item"
                        [ngClass]="getTeaserClass(idx)"
                    ></blog-post>
                }
            </div>
        </sew-ws-content-wrapper>
    }
    <!-- search result articles -->
    @if (showLoadMore) {
        <div class="tile-header">
            <blog-tile-header
                style="cursor: pointer"
                (click)="onLoadArticles()"
                [imgSrc]="'assets/images/round_icons/load_article.svg'"
                [text]="(labels | async)?.load_articles"
            ></blog-tile-header>
        </div>
    }
}

<!-- filtered articles -->
@if (filteredTags.length) {
    <blog-tag-articles
        [headline]="(labels | async)?.tag_articles"
        [filteredTags]="filteredTags"
        [filteredPosts]="filteredPosts"
        [breakpoint]="breakpoint"
        (removeTag)="filteredTagClicked($event)"
        (addTag)="tagClicked($event)"
        (displayArticle)="postClicked($event)"
    ></blog-tag-articles>
}
